import { reatomAsync, withDataAtom } from "@reatom/async";
import { GetCounterDto } from "definitions/counter-api";
import { API } from "src/api";

import { getCountersRequest } from "./getCountersRequest.ts";

export const deleteCounterRequest = reatomAsync(
  async (_, props: GetCounterDto) => {
    return API.counterApi
      .counterControllerDeleteCounter(props)
      .then((response) => response.data);
  },
  {
    name: "deleteCounterRequest",
    onFulfill: (ctx, { userId }) => {
      getCountersRequest(ctx, { userId });
    },
  },
).pipe(withDataAtom(null));
